import {Component} from "react";
import React from "react";
import PropTypes from 'prop-types';
const I18n = require('react-redux-i18n').I18n;
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { ErrorText } from "@common/components/error-text";

var localDateFormat; // define a proper date format due to browser locale

function getLocalFormat() {
    var testDate = new Date(Date.UTC(2017, 11, 31));
    var localDate = testDate.toLocaleDateString(window.navigator.userLanguage || window.navigator.language);
    return localDate.replace("2017", "yyyy").replace("12", "mm").replace("30", "dd").replace("31", "dd");
}

export default class PatientEnterDOBStep extends Component {

    constructor(props) {
        super(props);
        this.onOutsideClick = this.onOutsideClick.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onEnter = this.onEnter.bind(this);
        this.handleDateBlur = this.handleDateBlur.bind(this);

        var locale = window.navigator.userLanguage || window.navigator.language;
        localDateFormat = getLocalFormat();
        moment.locale(locale);
    }

    onOutsideClick() {
        this.datePicker.cancelFocusInput();
    }

    handleDateChange(value) {
        if (value.isValid()) {
            var result = moment(value).utc().add(value.utcOffset(), 'm');
            this.props.dobValueChanged(result);
            this.props.setEnteredDOBValid(true);
        } else {
            this.props.setEnteredDOBValid(false);
        }
    }

    handleDateBlur(target) {
        if (target.value === "") {
            this.props.setEnteredDOBValid(true);
        } else {
            var date = moment(target.value, "L", true);
            if (date.isValid()) {
                var result = moment(date).utc().add(date.utcOffset(), 'm');
                this.props.dobValueChanged(result);
                this.props.setEnteredDOBValid(true);
            } else {
                this.props.setEnteredDOBValid(false);
            }
        }
    }

    onEnter(e) {
        if (e.key === 'Enter') {
            this.props.validate()
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.onEnter)
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.onEnter)
    }

    render () {
        return (
            <div>
                <div className="patient-lookup-lbl">
                    {I18n.t('Patient Lookup')}
                </div>
                <div className="patient-lookup-field-lbl">
                    {I18n.t('Please Enter Your') + ' ' + this.props.dobField}
                </div>
                <div className={!this.props.enteredDOBValid ? "bootstrap form-group has-error" : "bootstrap form-group"}>
                    <DatePicker
                        id="dob"
                        ref={(node) => {this.datePicker = node;}}
                        className="form-control"
                        selected={this.props.enteredDOB ? moment(this.props.enteredDOB) : ''}
                        utcOffset='0'
                        onChange={(e) => {this.handleDateChange(e)}}
                        onBlur={(e) => {this.handleDateBlur(e.target)}}
                        disabledKeyboardNavigation
                        onClickOutside={this.onOutsideClick}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        autoComplete='off'
                    />
                    {!this.props.enteredDOBValid && (
                        <ErrorText withTopGap id="tooltip-right" text={`${I18n.t('Requires')} '${localDateFormat}' ${I18n.t('format')}`} />
                    )}
                </div>
                <div className="bootstrap field">
                    <button className="btn btn-default patient-lookup-button patient-lookup-left-btn-margin" onClick={this.props.goBack}>{I18n.t('Back')}</button>
                    <button className="btn btn-primary patient-lookup-button" disabled={!this.props.enteredDOBValid} onClick={this.props.validate}>{I18n.t('Confirm')}</button>
                </div>
            </div>
        );
    }
}

PatientEnterDOBStep.PropTypes = {
    dobField: PropTypes.string.isRequired,
    selected: PropTypes.object.isRequired,
    enteredDOB: PropTypes.string,
    enteredDOBValid: PropTypes.bool,
    setEnteredDOBValid: PropTypes.func,
    showSearchFailedMessage: PropTypes.func,
    dobValueChanged: PropTypes.func,
    validate: PropTypes.func,
    goBack: PropTypes.func
};